/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
export const colorVerdFosc = {
    background: "#007567",
    "&:hover": {
      background: "#007550",
    },
  };
  export const colorVermellFosc = {
    background: "#900000",
    "&:hover": {
      background: "#c00000",
    },
  };

